module.exports = __webpack_public_path__ + "img/category-skill-game-hover.b28e70f9.png";